import { render, staticRenderFns } from "./rmsYearSalesApp.vue?vue&type=template&id=52ac4e3e&scoped=true"
import script from "./rmsYearSalesApp.vue?vue&type=script&lang=js"
export * from "./rmsYearSalesApp.vue?vue&type=script&lang=js"
import style0 from "./rmsYearSalesApp.vue?vue&type=style&index=0&id=52ac4e3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ac4e3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCardTitle,VCol,VRow,VSkeletonLoader})
